import React, { useEffect, useRef, useState } from "react";
import styles from "../../../styles/about/components/AboutLeadership.module.css";
import apostleImg  from "../../../assets/images/father.png";
import serugoImg   from "../../../assets/images/RevEspoir.png";
import ngogaImg    from "../../../assets/images/ngoga.png";
import richardImg  from "../../../assets/images/richard.png";
import martinImg   from "../../../assets/images/Martin.png";
import { MdVerified } from "react-icons/md";
import { FaCross } from "react-icons/fa";

function useInView(threshold = 0.1) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setInView(true); observer.disconnect(); } },
      { threshold }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return [ref, inView];
}

const GLOBAL = [
  {
    name: "Apostle Christophe Sebagabo",
    title: "Representative",
    subtitle: "Visionary & Founder",
    img: apostleImg,
  },
  {
    name: "Rev. Espoir Serugo",
    title: "Legal Representative",
    subtitle: "Legal & Administration",
    img: serugoImg,
  },
];

const LOCAL = [
  {
    name: "Apostle Christophe Sebagabo",
    title: "Senior Pastor",
    subtitle: "Kigali Main Parish",
    img: apostleImg,
  },
  {
    name: "Rev. Espoir Serugo",
    title: "Pastor",
    subtitle: "Kigali Main Parish",
    img: serugoImg,
  },
  {
    name: "Pastor Ngoga Christophe",
    title: "Executive Pastor",
    subtitle: "Kigali Main Parish",
    img: ngogaImg,
  },
  {
    name: "Pastor Richard Sebagabo",
    title: "Social & Development",
    subtitle: "Kigali Main Parish",
    img: richardImg,
  },
  {
    name: "Pastor Martin Rutekereza",
    title: "Discipleship Division",
    subtitle: "Kigali Main Parish",
    img: martinImg,
  },
];

function LeaderCard({ person, size, delay, side }) {
  const [ref, inView] = useInView();
  const fromClass =
    side === "left" ? styles.fromLeft :
    side === "right" ? styles.fromRight :
    styles.fromBottom;

  return (
    <div
      ref={ref}
      className={`${styles.card} ${size === "large" ? styles.cardLarge : styles.cardSmall} ${fromClass} ${inView ? styles.cardVisible : ""}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <img src={person.img} alt={person.name} className={styles.cardBg} />
      <div className={styles.cardGradTop} />
      <div className={styles.cardGradBottom} />

      <div className={styles.cardContent}>
        <span className={styles.roleTag}>
          <MdVerified className={styles.roleIcon} />
          {person.subtitle}
        </span>
        <div className={styles.cardBottom}>
          <h3 className={styles.cardName}>{person.name}</h3>
          <p className={styles.cardTitle}>{person.title}</p>
        </div>
      </div>
    </div>
  );
}

export default function AboutLeadership() {
  const [headerRef, headerInView] = useInView(0.2);

  return (
    <section className={styles.section} id="leadership">
      <div className={styles.bg1} />
      <div className={styles.bg2} />

      <div className={styles.container}>

        {/* Header */}
        <div
          ref={headerRef}
          className={`${styles.header} ${headerInView ? styles.headerVisible : ""}`}
        >
          <div className={styles.eyebrow}>
            <FaCross className={styles.eyebrowIcon} />
            <span>Meet the Team</span>
            <FaCross className={styles.eyebrowIcon} />
          </div>
          <h2 className={styles.sectionTitle}>
            Servant <span className={styles.titleHighlight}>Leadership</span>
          </h2>
          <div className={styles.titleUnderline} />
          <p className={styles.sectionSub}>
            Guided by faith, driven by purpose — the leaders God has placed
            to shepherd Calvary Wide Fellowship Ministries.
          </p>
        </div>

        {/* Global Leadership */}
        <div className={styles.levelBlock}>
          <div className={styles.levelLabel}>Global Leadership</div>
          <div className={styles.globalGrid}>
            {GLOBAL.map((p, i) => (
              <LeaderCard
                key={i}
                person={p}
                size="large"
                delay={i * 130}
                side={i === 0 ? "left" : "right"}
              />
            ))}
          </div>
        </div>

        {/* Local Leadership */}
        <div className={styles.levelBlock}>
          <div className={styles.levelLabel}>Local Leadership — Kigali Main Parish</div>
          <div className={styles.localGrid}>
            {LOCAL.map((p, i) => (
              <LeaderCard
                key={i}
                person={p}
                size="small"
                delay={i * 100}
                side="bottom"
              />
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
